module.exports = __webpack_public_path__ + "img/bitManipulation.942294ce.svg";